import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button
} from '@mui/material';
import * as Icons from '@mui/icons-material';

// Icon mapping for template types
const getTemplateIcon = (icon) => {
  const iconName = Icons[icon];
  const iconElement = React.createElement(iconName, { sx: { fontSize: 40, color: "#E91E63" } });
  return iconElement;
};

const JournalTemplates = ({ templates = [], onSelectTemplate }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" fontWeight={600} mb={3}>
        Choose a Template
      </Typography>
      
      {templates.length === 0 ? (
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          minHeight="200px"
        >
          <Typography variant="body1" color="text.secondary">
            No templates available. Please try again later.
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gridTemplateRows: "repeat(2, minmax(0, 1fr))",
            gap: 3,
            width: "100%",
            maxWidth: "1200px",
            margin: "0 auto"
          }}
        >
        {templates.map((template) => {
          // Parse prompts if they're in string format
          const prompts = typeof template.prompts === 'string' 
            ? template.prompts.split('\n').filter(p => p.trim())
            : template.prompts || [];
          
          return (
            <Card
              key={template.id}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                transition: "all 0.3s ease",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 6
                }
              }}
              onClick={() => onSelectTemplate(template)}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  {getTemplateIcon(template.glyph)}
                  <Typography variant="h6" fontWeight={600} ml={2}>
                    {template.title || template.name}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary" paragraph>
                  {template.description}
                </Typography>
               
                  <Box component="ul" sx={{ pl: 2, mb: 0 }}>
                    
                      <Typography
                        key={template.id}
                        component="li"
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 1 }}
                      >
                        {template.text}
                      </Typography>
                   
                  </Box>
               
              </CardContent>
            </Card>
                     );
         })}
        </Box>
      )}
    </Box>
  );
};

export default JournalTemplates; 